<template>
  <div class="gs-video-card-skeleton" aria-hidden="true">
    <div class="gs-video-card-skeleton__media"></div>
    <div class="gs-video-card-skeleton__body">
      <div class="gs-video-card-skeleton__line gs-video-card-skeleton__line--title"></div>
      <div class="gs-video-card-skeleton__line gs-video-card-skeleton__line--meta"></div>
      <div class="gs-video-card-skeleton__line gs-video-card-skeleton__line--chip"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoCardSkeleton',
};
</script>

<style scoped>
.gs-video-card-skeleton {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gs-video-card-skeleton__media {
  aspect-ratio: 16 / 9;
  background: var(--gs-muted);
  animation: gs-video-card-skeleton-shimmer 1.2s ease-in-out infinite;
}

.gs-video-card-skeleton__body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px 16px;
}

.gs-video-card-skeleton__line {
  height: 12px;
  background: var(--gs-muted);
  border-radius: var(--gs-radius-sm);
  animation: gs-video-card-skeleton-shimmer 1.2s ease-in-out infinite;
}

.gs-video-card-skeleton__line--title {
  width: 70%;
  height: 15px;
}

.gs-video-card-skeleton__line--meta {
  width: 45%;
}

.gs-video-card-skeleton__line--chip {
  width: 30%;
  height: 18px;
  border-radius: 999px;
}

@keyframes gs-video-card-skeleton-shimmer {
  0%, 100% { opacity: 1; }
  50% { opacity: .55; }
}
</style>
